var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollapseArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.4383C24 0.718567 21.9681 -0.193883 20.6828 0.948647L12.6644 8.07612C12.2855 8.41291 11.7145 8.41291 11.3356 8.07612L3.31723 0.94865C2.03188 -0.193881 0 0.718567 0 2.4383C0 3.00761 0.24345 3.54974 0.668953 3.92796L10.6713 12.8189C11.429 13.4925 12.571 13.4925 13.3287 12.8189L23.331 3.92796C23.7565 3.54974 24 3.00761 24 2.4383Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collapse-arrow.f23e7aed97ab47a430433db07b01e767.svg";